window.theme = window.theme || {};
theme.routes = {
  home: "/",
  cart: "/cart.js",
  cartPage: "/cart",
  cartAdd: "/cart/add.js",
  cartChange: "/cart/change.js",
  search: "/search",
  predictiveSearch: "/search/suggest"
};
theme.strings = {
  soldOut: "Sold Out",
  unavailable: "Unavailable",
  inStockLabel: "In stock, ready to ship",
  oneStockLabel: "Low stock - [count] item left",
  otherStockLabel: "Low stock - [count] items left",
  willNotShipUntil: "Ready to ship [date]",
  willBeInStockAfter: "Back in stock [date]",
  waitingForStock: "Backordered, shipping soon",
  savePrice: "Save [saved_amount]",
  cartEmpty: "Your cart is currently empty.",
  cartTermsConfirmation: "You must agree with the terms and conditions of sales to check out",
  searchCollections: "Collections",
  searchPages: "Pages",
  searchArticles: "Articles",
  productFrom: "from ",
  maxQuantity: "You can only have [quantity] of [title] in your cart."
};
theme.settings = {
  cartType: "drawer",
  isCustomerTemplate: null,
  moneyFormat: null,
  saveType: "dollar",
  productImageSize: "natural",
  productImageCover: false,
  predictiveSearch: true,
  predictiveSearchType: null,
  predictiveSearchVendor: false,
  predictiveSearchPrice: false,
  quickView: false,
  themeName: "Impulse",
  themeVersion: "7.5.1"
};

window.WSAIO = window.WSAIO || {};
if (typeof window.WSAIO.loginLink !== "function") {
  window.WSAIO.loginLink = function (url) {
    if (url) {
      return url;
    }
    if (window.WSAIO.local_param) {
      return window.WSAIO.local_param + "account/login";
    }
    return "/account/login";
  };
}
